module.exports = __webpack_public_path__ + "static/media/npm.4ffaf293.svg";